import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';
declare var $:any;

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent {

  public dataListing:any=[];
  public loading:boolean = true;
  public loginDetail:any =[];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  public searchKey1:any='';
  public Ids:any='';
  public CurrentUrl:any=this.router.url;
  public userNames:any= localStorage.getItem('hva_usertr_name');
  public largeView:any='';


  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = JSON.parse(localStorage.getItem('hva_login') || "{}");   
    if(this.CurrentUrl=='/feedback'){
      this.getDetail1(this.p);
    } else {
      this.getDetail(this.p);
    }
   }

  ngOnInit(): void {
  }

    getDetail(page:any){ 
      this.loading=true;
      var url:any='';
      if(this.CurrentUrl=='/report-user') {
        url='report-list?page=' +page;
      } else if(this.CurrentUrl=='/report-comment') {  
        url='comment-report-list?page=' +page;
      } else {
        url='post-report-list?page=' +page;
      }
      this.service.GetApi(url).subscribe(((response:any)=>{
        if(response.success ==1) {  
          var self =this;  
          this.loading=false;
          if(this.CurrentUrl=='/report-post' || this.CurrentUrl=='/report-comment') {
            response.data.filter((el:any)=>{
              let extension = el.postData.content.split('.').pop();
              if(extension=='mp4' || extension=='wmv' || extension=='avi' || extension=='3gp' ){
                el.postData.type=1;
              } else {
                el.postData.type=2;
              }
            })
          }
          this.dataListing=response.data;
          this.totalCount =response.totalCounts;
        } else {
          this.dataListing=[];
          this.totalCount =response.totalCounts;
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
    }

    redirect(item:any,type:any,status:any){
      this.Ids =item._id;
      if(type ==3){
        this.delete(status);
      } else if(type ==2){
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
        }).then((result:any) => {
          let statusType: number = 0;
          if (result.isConfirmed) {
           this.delete(status);
          }
        });
      } else if(type ==4){
        this.update(status);
      } else {
        localStorage.setItem('hva_messageView',JSON.stringify(item));
        this.router.navigate(['/report-detail']);
      }
    }
  
    delete(status:any){
      var url='/report/'+ this.Ids; 
      var detail={
        "status": status
      }
      this.service.updateApi1(detail,url).subscribe(((response:any)=>{
        if(response.success==1) {  
          this.loading=false;
          this.p=1;
          this.getDetail(this.p);
        } else {
          this.service.dangerAlert(response.message);
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
  
    }

    update(status:any){
      var url='/update-post/'+ this.Ids; 
      var detail={
        "status": status
      }
      this.service.updateApi1({},url).subscribe(((response:any)=>{
        if(response.success==1) {  
          this.loading=false;
          this.p=1;
          this.getDetail(this.p);
        } else {
          this.service.dangerAlert(response.message);
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
  
    }

    getDetail1(page:any){ 
      this.loading=true;
      var url:any='/user-feedbacks?page=' +page;       
      this.service.GetApi(url).subscribe(((response:any)=>{
        if(response.success ==1) {  
          var self =this;  
          this.loading=false;
          this.dataListing=response.data;
          this.totalCount =response.totalCounts;
        } else {
          this.dataListing=[];
          this.totalCount =response.totalCounts;
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
    }

    close(name:any){
      $(name).modal('toggle');
      this.largeView='';
    }

    approve(id:any,type:any){
      var url='';
      if(type==1){
        url="approve-user-report/"+id;
      } else if(type==2){
        url="approve-post-report/"+id;
      } else {
        url="approve-comment-report/"+id;
      }
      this.service.updateApi1({},url).subscribe(((response:any)=>{
        if(response.success==1){
          this.getDetail(1);
        } else {
          this.service.dangerAlert(response.message);
        }
      }))

    }

    reject(id:any,type:any){
      var url='';
      if(type==1){
        url="ignore-user-report/"+id;
      } else if(type==2){
        url="ignore-post-report/"+id;
      } else {
        url="ignore-comment-report/"+id;
      }
      this.service.updateApi1({},url).subscribe(((response:any)=>{
        if(response.success==1){
          this.getDetail(1);
        } else {
          this.service.dangerAlert(response.message);
        }
      }))

    }
}

